import styles from "./statusBadge.module.css";

// Small status pill in the admin look. With onClick it is a button.
// tone: info | attention | success | critical | neutral | violet
export default function StatusBadge({ tone = "neutral", children, onClick, title }) {
  const className = `${styles.badge} ${styles[tone] || styles.neutral} ${onClick ? styles.clickable : ""}`;
  return onClick ? (
    <button type="button" className={className} onClick={onClick} title={title}>
      {children}
    </button>
  ) : (
    <span className={className} title={title}>
      {children}
    </span>
  );
}
